import { Outlet } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';

const Layout = ({ hideHeaderFooter, hideLanguageSwitcher }) => {
  return (
    <>
      {!hideHeaderFooter && <Header hideLanguageSwitcher={hideLanguageSwitcher} />}
      <Outlet />
      {!hideHeaderFooter && <Footer />}
    </>
  );
};

export default Layout;